<template>
  <div>
    <b-form class="form profile-name">
      <b-row>
        <b-col cols="5">
          <b-form-group>
            <label for="match-size">Match Size</label>
            <b-form-spinbutton
              id="match-size"
              v-model="matchSize"
              :min="matchSizeMin"
              :max="matchSizeMax"
            />
          </b-form-group>
          <b-form-group>
            <label for="sb-match-groups">Match Group</label>
            <b-form-select
              id="sb-matchGroups"
              v-model="matchGroup"
              :options="matchGroups"
            />
          </b-form-group>
          <b-form-group>
            <label
              v-for="(aToggle, i) in toggles"
              class="notification"
              :value="aToggle.name"
              :key="`tog_${i}`"
            >
              <div class="toggler" :class="[aToggle.value ? 'bg' : '']">
                <div
                  class="slider"
                  :class="[aToggle.value ? 'btns' : '']"
                ></div>
              </div>
              <div class="notification-content">
                <h6>{{ aToggle.name }}</h6>
                <p>
                  {{ aToggle.text }}
                </p>
              </div>
              <input
                type="checkbox"
                class="invisible"
                @change="handleUpdateSettings(aToggle.property, aToggle.value)"
                v-model="aToggle.value"
              />
            </label>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    <b-button
      variant="primary btn-round-fill"
      @click.prevent="handleUpdateSettings"
    >
      Save Settings
    </b-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Settings_MatchGame",
  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.handleInitWithSettings();
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      getLocalPublishingWithId: "user/getLocalPublishingWithId",
      hasPermission() {
        return true;
      }
    }),
    settings() {
      //mixin?
      if (this.resource && this.resource.settings)
        return this.resource.settings; //TDO move to MIXIN
      return {};
    },
    video() {
      return this.resource.data &&
        this.resource.data.settings &&
        this.resource.data.settings.video &&
        this.resource.data.settings.video
        ? this.resource.data.settings.video
        : null;
    },
    videoId() {
      return this.video && this.video.videoId ? this.video.videoId : null;
    },
    videoURL() {
      return this.video && this.video.videoURL ? this.video.videoURL : null;
    },
    thumbURL() {
      return this.video && this.video.thumbURL ? this.video.thumbURL : null;
    }
  },
  methods: {
    handleInitWithSettings() {
      this.matchSize = this.settings.user.matchSize
        ? this.settings.user.matchSize
        : 2;
      this.matchGroup = this.settings.user.matchGroup;
    },
    localPublishingWithId(pubId) {
      return this.getLocalPublishingWithId(pubId);
    },
    handleUpdateSettings() {
      //can be a mixin
      let settings = {
        gen: {},
        user: {
          matchSize: this.matchSize,
          matchGroup: this.matchGroup
        }
      };
      this.$emit("update-settings", settings);
    }
  },
  data() {
    return {
      matchSize: 1,
      matchSizeMin: 1,
      matchSizeMax: 5,
      value: 0,
      matchGroup: "fruits",
      matchGroups: [
        { value: "fruits", text: "Fruits" },
        { value: "animals", text: "Animals" },
        { value: "logos", text: "Logos" }
      ],
      toggles: [
        {
          name: "Sound",
          property: "_isSoundOn",
          type: "btns",
          text: "Turn on the Sound",
          value: false
        },
        {
          name: "Display Stats",
          property: "_isDisplayStats",
          type: "btns",
          text: "Displays # of [Turns] and [Total Time]",
          value: false
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .notification-content {
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
</style>
